/* eslint-disable */
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import Img from "../components/Img";
import { style } from "./LocationDetail";

function fmtPricing(pricing) {
  if (!pricing) return [];
  const rows = [];
  const push = (label, cents) => { if (cents) rows.push([label, `$${(cents/100).toFixed(0)}`]); };
  push("Hourly", pricing.hourly_cents);
  push("Half-day", pricing.half_day_cents);
  push("Full-day", pricing.full_day_cents);
  push("Day pass", pricing.day_pass_cents);
  push("Weekly", pricing.weekly_cents);
  push("Monthly", pricing.monthly_cents);
  return rows;
}

export default function WorkspaceResourceDetail() {
  const { locationSlug, resourceSlug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/inventory-v2/locations/${locationSlug}/workspaces/${resourceSlug}`)
      .then(r => setData(r.data))
      .catch(e => setError(e?.response?.data?.detail || e.message));
  }, [locationSlug, resourceSlug]);

  if (error) return <div style={{...style.wrap, padding:60}}>Error: {error}</div>;
  if (!data) return <div style={{...style.wrap, padding:60}}>Loading…</div>;

  const { resource: r, location: loc, organization: org } = data;
  const isParentFallback = r.booking_url_source === "parent_fallback";
  const pricing = fmtPricing((r.workspace || {}).pricing);

  return (
    <div style={style.wrap} data-testid="v2-workspace-detail">
      <div style={style.banner}>Métier · Inventory V2 Preview · Admin only</div>
      <main style={style.main}>
        <div style={{fontSize:12, color:"#666"}}>
          Métier › <Link to={`/locations/${loc.slug}`} style={{color:"#666"}}>{loc.name}</Link> › <strong>{r.name}</strong>
        </div>
        <span style={{...style.eyebrow, marginTop:12, display:"inline-block"}}>Workspace · {r.workspace_type?.replace(/_/g, " ")}</span>
        <h1 style={style.h1}>{r.name}</h1>
        <div style={style.meta}>{loc.name}{loc.city ? ` · ${loc.city}` : ""}{loc.state ? `, ${loc.state}` : ""} · Capacity {r.capacity || "—"}</div>

        {r.images?.length > 0 && (
          <div style={style.gallery}>
            {r.images.slice(0, 3).map((g, i) => <Img key={i} src={g} alt={`${r.name} ${i + 1}`} style={style.galleryImg} />)}
          </div>
        )}

        {r.description ? <p style={{maxWidth:720, marginTop:24, lineHeight:1.7}}>{r.description}</p> : null}

        {pricing.length > 0 && (
          <>
            <h2 style={style.h2}>Pricing</h2>
            <table style={{fontSize:14, borderCollapse:"collapse"}}>
              <tbody>
                {pricing.map(([label, val]) => (
                  <tr key={label}><td style={{padding:"6px 24px 6px 0", color:"#666"}}>{label}</td><td style={{padding:"6px 0", fontFamily:"'Cormorant Garamond', serif", fontSize:20}}>{val}</td></tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {r.amenities?.length > 0 && (
          <>
            <h2 style={style.h2}>Workspace amenities</h2>
            <div style={style.amenityRow}>
              {r.amenities.map(a => <span key={a} style={style.chip}>{a}</span>)}
            </div>
          </>
        )}

        {/* BOOKING PANEL */}
        <div style={{background:"#fff", padding:24, marginTop:32, border:"1px solid #ddd", borderRadius:8, maxWidth:640}}>
          <div style={style.eyebrow}>Booking</div>
          <div style={{fontSize:13, color:"#666", margin:"4px 0 14px"}}>
            {r.booking_mode?.replace(/_/g, " ")} · {r.management_mode?.replace(/_/g, " ")}
          </div>
          <a
            href={r.external_booking_url || loc.default_booking_url || "#"}
            target="_blank" rel="noopener noreferrer"
            data-testid="v2-book-cta"
            style={{
              display:"inline-block",
              background:"var(--gold, #B8913A)", color:"#fff",
              padding:"12px 22px", fontSize:12, letterSpacing:"0.14em",
              textTransform:"uppercase", textDecoration:"none", borderRadius:2,
            }}
          >{r.cta_text}</a>
          {r.cta_disclosure && (
            <p style={{fontSize:12, color:"#666", marginTop:12, fontStyle:"italic"}} data-testid="v2-book-disclosure">
              {r.cta_disclosure}
            </p>
          )}
          {isParentFallback && (
            <p style={{fontSize:11, color:"#a04b00", marginTop:12, letterSpacing:"0.04em"}} data-testid="v2-fallback-label">
              <strong>Note:</strong> This link opens the parent {org?.name || "operator"} listing, not this specific room. Direct booking URLs are in progress.
            </p>
          )}
        </div>
      </main>
    </div>
  );
}
